import styled from 'styled-components';
import { colors, FlexContainer } from '@taxdown/piccolo-web';
import Lottie from 'Components/UI/Lottie';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';
import { FRONT_PLANS } from 'Constants/plans';

export const ColorByPlan = {
  [FRONT_PLANS.PRO]: colors.pro_200,
  [FRONT_PLANS.FULL]: colors.full_200,
  [FRONT_PLANS.FLEX]: colors.live_200,
};

export const StyledContainer = styled(FlexContainer)<{ plan: FRONT_PLANS }>`
  background: ${({ plan }) => (plan ? ColorByPlan[plan] : colors.pro_200)};
  min-height: 100vh;
  padding: ${({ theme: { reference } }) => reference.dimension_24};
  animation: slide-in-bottom 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  @keyframes slide-in-bottom {
    0% {
      transform: translateY(1000px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const StyledLottie = styled(Lottie)`
  width: 250px;
  height: 370px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: 300px;
    height: auto;
  }
`;

export const PlanLogoContainer = styled(FlexContainer)`
  img {
    max-height: 40px;
    width: auto;
  }
`;
